import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const addSubscriptionSchema = Yup.object().shape({
    location: Yup.array().required(CommonMessages.location_required).min(1, 'Select Location.'),
    subscription: Yup.string().required(CommonMessages.subscription_required),
    washname: Yup.string().required(CommonMessages.washname_required),
    washdetails: Yup.string().required(CommonMessages.washdetails_required),
    washnumber: Yup.string()
      .nullable()
      .when('isUnlimitedWash', {
        is: false,
        then: schema =>
          schema
            .required(CommonMessages.washnumber_required)
            .matches(/^([1-9][0-9]{0,2})$/, 'Enter valid count.'),
        otherwise: schema => schema.notRequired(),
      }),
      isUnlimitedWash:Yup.boolean(),
      isPriceHoldEnabled: Yup.boolean(),
      isPriceHoldEmail: Yup.boolean(),
    maxwashperday: Yup.string()
        .nullable()
        .transform(value => (value === "" ? null : value)) // Treat empty string as null
        .when(['subscription', 'isUnlimitedWash'], {
    is: (subscription: string, isUnlimitedWash: boolean) =>
      subscription === 'month' && isUnlimitedWash === false,
            then: schema =>
                schema
                    .required(CommonMessages.maxwashnumber_required)
                    .matches(/^([1-9][0-9]{0,2})$/, 'Enter a valid count.')
                    .test(
                        'maxwashperday-less-than-washnumber',
                        CommonMessages.wash_per_day_exceed,
                        function (value) {
                            const { washnumber } = this.parent;
                            const maxwashValue = parseInt(value, 10);
                            const washnumberValue = parseInt(washnumber, 10);

                            if (!value || isNaN(maxwashValue) || isNaN(washnumberValue) ) {
                                return false;
                            }
                            return maxwashValue <= washnumberValue;
                        }
                    ),
            otherwise: schema => schema.notRequired(),
        }),
    amount: Yup.string().matches(/^\d{0,8}(\.\d{0,2})?$/, 'Enter amount.').required(CommonMessages.amount_required),
    numberOfVacuumWashes: Yup.number()
        .nullable()
        .when('hasVacuumWash', {
          is: true,
          then: schema =>
            schema
              .typeError('Enter a valid number of vacuum washes.')
              .min(1, 'Number of vacuum wash must be greater than 0.')
              .required('Number of vacuum washes is required.'),
          otherwise: schema => schema.notRequired(),
        }),
    
      maxVacuumTime: Yup.number()
        .nullable()
        .when('hasVacuumWash', {
          is: true,
          then: schema =>
            schema
              .typeError('Enter a valid vacuum time.')
              .min(1, 'Maximum vacuum must be greater than 0.')
              .required('Maximum vacuum time is required.'),
          otherwise: schema => schema.notRequired(),
        }),
})